import React from 'react';
import { Button, Modal, Stack } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getNewVersionReload, updateNewVersionReload } from '@soulhx/client-store';
import { useTranslation } from 'react-i18next';

const NUM_MINUTES_TO_DELAY = 5;

export const NewVersionReload = () => {
  const newVersionReload = useSelector(getNewVersionReload);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Modal show={newVersionReload} centered backdrop="static" animation>
      <Modal.Header closeButton={false}>
        <Modal.Title>{t('general.appName')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack gap={3} direction="vertical">
          <div>{t('reload.reloadMsg')}</div>

          <Button
            variant="success"
            onClick={() => {
              dispatch(updateNewVersionReload(false));
              const customWindow = window as Window & { skipWaitingAndReload?: () => void };
              if (customWindow.skipWaitingAndReload) {
                customWindow.skipWaitingAndReload();
              } else {
                window.location.reload();
              }
            }}
          >
            {t('reload.reloadBtn')}
          </Button>

          <Button
            variant="warning"
            onClick={() => {
              dispatch(updateNewVersionReload(false));

              setTimeout(
                () => {
                  dispatch(updateNewVersionReload(true));
                },
                1000 * 60 * NUM_MINUTES_TO_DELAY
              );
            }}
          >
            {t('reload.delayBtn', { numMinutes: NUM_MINUTES_TO_DELAY })}
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  );
};
